import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a popup
 */
export default class PointOfInterestHotspot extends BaseHotspot {
  /**
   * Initialises an note hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'poi',
   *   options: {
   *     name: string,
   *     onEnter: boolean,
   *     activeDirections: [string] | null
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    if (this.player.mode === "editor") {
      this.loadTexture({
        url: `${window.location.origin}/tour/assets/hotspots/poi.png`,
      });
    } else {
      this.setInactive();
      this._hasTooltip = false;
      this._tooltip = undefined;

      if (
        config.options.onEnter &&
        (!config.options.activeDirections ||
          config.options.activeDirections.includes(this.player.previousScene))
      ) {
        setTimeout(() => this.lookAtMe(config.options.name), 1500);
      }
    }

    this._config = config;
  }
}
